export enum FinancialInstallmentEditTypeEnum {
    ALL = 'Todas as parcelas',
    OPENED = 'Parcelas em aberto',
    PAID = 'Parcelas pagas',
    OVERDUE = 'Parcelas vencidas'
}
